import axios from "axios";
import store from "@/store";
import * as C from "@/common";
import { Api } from "./api";
import * as A from "@/core/account";


export interface IAdminUserRegistration {
	"ID": string;
	"Mail": string;
	"LastLogin": string | null;
	"FailedLoginAttempts": null | string;
	"LastFailedLogin": string | null;
	"FirstName": string | null;
	"LastName": string | null;
	"Adress_Zip": string | null;
	"Adress_City": string | null;
	"Adress_Street": string | null;
	"Adress_Number": string | null;
	"Adress_Country": string | null;
	"Birthdate": string | null;
	"MobilePhone": string | null;
	"Nickname": string | null;
	"Species": string | null;
	"ProfilePicture": string | null;
	"IsAdmin": string | null;
	"IsMailConfirmed": string | null;
	"HasDog": string | null;
	"HasFursuit": string | null;
	"Arrival": string | null;
	"Duration": string | null;
	"RegistrationDate": string | null;
	"Intolerances": string | null;
	"ShirtAmount": string | null;
	"ShirtSize": string | null;
	"Sponsor": string | null;
	"Status": string | null;
	"StatusText": string | null;
	"RegMailSent": string | null;
	"TotalCost": string | null;
	"Number": string | null;
	"Groups": string | null;
	"AcceptRules": string | null;
	"AcceptGdpa": string | null;
}

export enum MailType {
	SendBill = "bill",
	ConfirmPayment = "confirmPayment",
}

declare type Translator<T> = (key: string) => string;

export class AdminApi extends Api {

	private readonly urlAdminPart = "admin/";
	private readonly translator: Translator<any>;
	public constructor(translator: Translator<any>) {
		super();
		this.translator = translator;
	}

	protected get BaseUrl() {
		return super.BaseUrl + this.urlAdminPart;
	}

	public async loadAll(): Promise<IAdminUserRegistration[]> {
		const user = await this.executeWithErrorHandling(() => axios.get<IAdminUserRegistration[]>(`${this.BaseUrl}all`, this.Config));

		return user.data.map(r => this.convertFromServer(r));
	}

	public async sendMail(userId: string, type: MailType, locale: string) {
		await this.executeWithErrorHandling(() => axios.get<void>(`${this.BaseUrl}sendMail/${type}/${userId}/${locale}`, this.Config));
		return;
	}
	public async cancelReg(userId: string) {
		await this.executeWithErrorHandling(() => axios.get<void>(`${this.BaseUrl}cancel/${userId}`, this.Config));
		return;
	}
	public async anullReg(userId: string) {
		await this.executeWithErrorHandling(() => axios.get<void>(`${this.BaseUrl}anull/${userId}`, this.Config));
		return;
	}
	public async resetPassword(userId: string) {
		await this.executeWithErrorHandling(() => axios.get<void>(`${this.BaseUrl}reset/${userId}`, this.Config));
		return;
	}


	private convertFromServer(reg: IAdminUserRegistration): IAdminUserRegistration {
		const fnConvertBool = (v: string | null) => v === "1" ? "Ja" : "Nein";
		const converted = {
			ID: reg.ID,
			Mail: reg.Mail,
			LastLogin: reg.LastLogin,
			FailedLoginAttempts: reg.FailedLoginAttempts,
			LastFailedLogin: reg.LastFailedLogin,
			FirstName: reg.FirstName,
			LastName: reg.LastName,
			Adress_Zip: reg.Adress_Zip,
			Adress_City: reg.Adress_City,
			Adress_Street: reg.Adress_Street,
			Adress_Number: reg.Adress_Number,
			Adress_Country: reg.Adress_Country,
			Birthdate: reg.Birthdate,
			MobilePhone: reg.MobilePhone,
			Nickname: reg.Nickname,
			Species: reg.Species,
			ProfilePicture: reg.ProfilePicture,
			IsAdmin: fnConvertBool(reg.IsAdmin),
			IsMailConfirmed: fnConvertBool(reg.IsMailConfirmed),
			HasDog: fnConvertBool(reg.HasDog),
			HasFursuit: fnConvertBool(reg.HasFursuit),
			Arrival: reg.Arrival,
			Duration: reg.Duration,
			RegistrationDate: reg.RegistrationDate,
			Intolerances: reg.Intolerances,
			ShirtAmount: fnConvertBool(reg.ShirtAmount),
			ShirtSize: reg.ShirtSize,
			Sponsor: fnConvertBool(reg.Sponsor),
			Status: reg.Status,
			StatusText: reg.Status ? this.translator(`reg_status_${reg.Status}`) : "",
			RegMailSent: reg.RegMailSent,
			TotalCost: reg.TotalCost,
			Number: reg.Number,
			Groups: reg.Groups,
			AcceptRules: fnConvertBool(reg.AcceptRules),
			AcceptGdpa: fnConvertBool(reg.AcceptGdpa),
		};
		if (converted.Status === "0" && converted.AcceptGdpa !== "Ja" && converted.AcceptRules !== "Ja")
			converted.StatusText = this.translator("reg_status_-1");

		return converted;
	}

}
